<template>
    <NavView></NavView>
    <SideBar></SideBar>
    <div class="container-fluid ">
        <h6 class="manage-boder pt-2 font1 font-bold1"> <router-link class="decoration" to="/"> Dashbord </router-link><span class="pfimg1"></span>   </h6>
    <div class="card" >
        <div class="card-body">
        
                <div class="mb-4 card container-fluid">
                    <CChart
                    type="bar"
                    :data="{
                        labels: ['January', 'February', 'March','april','May','June','July','August','September','October','November','December' ],
                        datasets: [
                        {
                            label: 'Monthly Sales Summary 2022',
                            backgroundColor: '#83C2FA ',
                            data: [50, 20, 12, 40, 20, 5, 25, 35, 10, 0, 15, 45],
                        },
                        ],
                    }"
                    labels="months"
                    />
                </div>
                <div class="mb-4 card container-fluid">

             
                     <CChart
                    type="bar"
                    :data="{
                        labels: ['January', 'February', 'March','april','May','June','July','August','September','October','November','December' ],
                        datasets: [
                        {
                            label: 'Monthly Cash Collection Summary 2022',
                            backgroundColor: '#83C2FA ',
                            data: [0, 20, 0, 40, 20, 0, 25, 35, 5, 0, 15, 45],
                        },
                        ],
                    }"
                    labels="months"
                    />

                </div>

                <div class="card mb-5">
                 <div class="row container-fluid">
                    <div class="col-md-6  ">
                        <CChart
                        type="pie"
                        :data="{
                          labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
                          datasets: [
                            {
                              backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
                              data: [40, 20, 80, 10],
                            },
                          ],
                        }"
                      />
                    </div>
                    <div class="col-md-6 ">
                        <CChart
                        type="pie"
                        :data="{
                          labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
                          datasets: [
                            {
                              backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
                              data: [25, 40, 10, 10],
                            },
                          ],
                        }"
                      />
                    </div>

                 </div>   
                </div>
                
               
           
            






        </div>
    </div>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  // import HelloWorld from '@/components/HelloWorld.vue'
  import NavView from '../../components/NavView.vue'
  import SideBar from '../../components/SideBar.vue'
  import { CChart } from '@coreui/vue-chartjs'
  

  

  
  export default {
   
    components: {
      NavView,SideBar,CChart
     },

  data () {
    return {
    
  }
  },
}
  </script>
  <style>
      .manage-boder{
  border-bottom: 2px solid #E9E9E3;
  border-top: 2px solid #E9E9E3;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
  
  }

  .font1{
  font-size: 13px !important;

}
.font-bold1{
  font-weight: bold;
}
.decoration{
  text-decoration: none;
  color:#A5A5A3  ;
}
.w-35{
    width: 35%;
}
  </style>
  